import { useTranslation } from "react-i18next";
import { createFileRoute } from "@tanstack/react-router";

import { validateAuthToken } from "@/guards/validateAuthToken";
import { validateActiveUser } from "@/guards/validateActiveUser";

import { SectionRoute } from "@/components/shared/SectionRoute";
import { StateMessageFactory } from "@/components/shared/state-messages/StateMessageFactory";

export const Route = createFileRoute("/dashboard/patients/new/sent")({
  beforeLoad: () => {
    validateAuthToken();
    validateActiveUser();
  },
  component: InvitationSent,
});

function InvitationSent() {
  const { t } = useTranslation();

  return (
    <>
      <SectionRoute
        route_one={t("routes.dashboard")}
        route_two={t("routes.patients")}
        route_two_link="/dashboard/patients"
        route_three={t("routes.add_patients")}
        route_three_link="/dashboard/patients/new"
        route_four={t("routes.success")}
      />

      <div className="mt-12 2xl:mt-24 mx-auto xl:max-w-4/5 2xl:max-w-3/5">
        {StateMessageFactory("invitation-sent")}
      </div>
    </>
  );
}
